const TableContainer = ({ children, className = '', innerRef = null }) => {
  const classes = ['common-table__container', className].filter(Boolean).join(' ');

  return <div ref={innerRef} className={classes}>{children}</div>;
};

export default TableContainer;
